import request from "./http";

const serve = {
  getConfig(params) {
    return request({
      url: "/config/getConfig",
      method: "get",
      params,
    });
  },
  getDirList(params) {
    return request({
      url: "/helpcenter/getDirList",
      method: "get",
      params,
    });
  },
  getDocDetail(params) {
    return request({
      url: "/helpcenter/getDocDetail",
      method: "get",
      params,
    });
  },
  setComment(data) {
    return request({
      url: "/helpcenter/postComment",
      method: "post",
      data,
    });
  },
  searchData(data) {
    return request({
      url: "/helpcenter/postSearchQs",
      method: "post",
      data,
    });
  },
  getResource() {
    return request({
      url: "/cms/getResource",
      method: "get",
    });
  },
  getNews(params) {
    return request({
      url: "/cms/getResourceList",
      method: "get",
      params,
    });
  },
  getNewsDetail(params) {
    return request({
      url: "/cms/articleDetail",
      method: "get",
      params,
    });
  },
  getHotQs() {
    return request({
      url: "/helpcenter/getHotQs",
      method: "get",
    });
  },
  getVideoList(params) {
    return request({
      url: "/helpcenter/getVideoList",
      method: "get",
      params,
    });
  },
  getJobInfo(){
    return request({
      url: "/lib/e80f8f761fa2d1d0.json",
      method: "get",
    });
  },
};
export default serve;
